import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Amount } from '../../../../../common/components/Amount';
import { getValue } from '../../../../../common/global/helpers';
import Breadcrumbs from '../../../../../common/widgets/Breadcrumbs';
import Icons from '../../../../../common/widgets/Icons';
import { CustomerBudgetContext } from '../../../contexts/CustomerBudgetContext';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { PlatformBenefitTypes } from '../../../enums';
import { resources } from '../../../resources/resources';
import applicationCrumbs from '../../ApplicationCrumbs';
import PlatformInformation from '../../Common/PlatformInformation';
import MyAccountMenu from '../Common/MyAccountMenu';
import { MyCards } from '../Common/MyCards';
import { OrdersStatistics } from '../Common/OrdersStatistics';
import { OrdersAndTransactionsForDashboard } from '../OrdersPage/Common/OrdersAndTransactionsForDashboard';
import { SubscriptionsForDashboard } from '../SubscriptionsPage/Components/SubscriptionsForDashboard';
import NewsletterDialog from './Dialogs/NewsletterDialog';

export const DashboardPage = () => {
  const { customerInfo } = useContext(CustomerInfoContext);
  const { customerBudget } = useContext(CustomerBudgetContext);
  const [hideNewsletterDialog, setHideNewsletterDialog] = useState(false);

  const { t: translate } = useTranslation();
  const crumbs = applicationCrumbs(translate);
  const currentMonth = new Date().getMonth() + 1;

  const isFlexibleBenefits = customerInfo.platformType === PlatformBenefitTypes.FlexibleBenefits;
  const showCards = customerInfo.canAccessMyCards;
  const showSubscriptions = customerInfo.canAccessSubscriptions;

  const showNewsletterDialog =
    !hideNewsletterDialog &&
    customerInfo.showNewsletterPopup &&
    !customerInfo.isSavingsUser;

  return (
    <>
      <Breadcrumbs entries={[crumbs.home, crumbs.accountDashboard]} />
      <section className="section-main section-actions my-account-page my-account-dashboard">
        <div className="container">
          <div className="area-actions">
            <MyAccountMenu />
          </div>

          <div className="area-content">
            <PlatformInformation />

            {/*My budget cards*/}
            {customerInfo.platformType === PlatformBenefitTypes.FlexibleBenefits && (
              <div className="mydash-budget-cards">
                <div className="row equal-heights-content">
                  <div className="col col-3 col-md-6 col-xs-3">
                    <div className="mydash-budget-card">
                      <div className="mydash-budget-label">
                        {translate(
                          resources.accountDashboard.availableBenefitBudget,
                        )}
                      </div>
                      <div className="mydash-budget-balance">
                        <Amount
                          value={customerBudget?.benefitBudgetBalance}
                        ></Amount>
                      </div>
                    </div>
                  </div>

                  <div className="col col-3 col-md-6 col-xs-3">
                    <div className="mydash-budget-card">
                      <div className="mydash-budget-label">
                        {translate(
                          resources.accountDashboard.budgetAddedThisMonth,
                        )}{' '}
                        {translate(
                          getValue(resources.months, currentMonth.toString()),
                        )}
                      </div>
                      <div className="mydash-budget-balance">
                        <Amount
                          value={customerBudget?.budgetAddedThisMonth}
                        ></Amount>
                      </div>
                    </div>
                  </div>

                  <div className="col col-3  col-md-6 col-xs-3">
                    <div className="mydash-budget-card">
                      <div className="mydash-budget-label">
                        {translate(resources.accountDashboard.taxesThisMonth)}{' '}
                        {translate(
                          getValue(resources.months, currentMonth.toString()),
                        )}
                      </div>
                      <div className="mydash-budget-balance">
                        <Amount value={customerBudget?.taxesThisMonth}></Amount>
                      </div>
                    </div>
                  </div>

                  <div className="col col-3 col-md-6 col-xs-3">
                    <div className="mydash-budget-card">
                      <div className="mydash-budget-label">
                        {translate(
                          resources.accountDashboard
                            .availableBenefitBucksBudget,
                        )}
                      </div>
                      <div className="mydash-budget-balance">
                        <Amount
                          value={customerBudget?.benefitBucksBalance}
                        ></Amount>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/*Cards and statistics*/}
            <div className="row mydash-info">
              {showCards && (
                <div className="col col-4 col-lg-6 col-md-6 col-sm-12">
                  <MyCards />
                </div>
              )}

              {isFlexibleBenefits && <div
                className={`col ${
                  showCards ? 'col-8' : 'col-12'
                } col-lg-6 col-md-6 col-sm-12`}
              >
                <OrdersStatistics />
              </div>}
            </div>

            {/*My orders*/}
            <div className="panel padding-xl">
              <h2 className="mydash-link-title">
                <Link to="/my-account/orders">
                  <span>{translate(resources.accountDashboard.myOrders)}</span>
                  <span className="mydash-title-icon">
                    <Icons.ArrowRight />
                  </span>
                </Link>
              </h2>
              <OrdersAndTransactionsForDashboard />
            </div>
            {/*My subscriptions*/}
            {showSubscriptions && (
              <div className="panel padding-xl">
              <h2 className="mydash-link-title">
                <Link to="/my-account/subscriptions">
                  <span>
                    {translate(resources.accountDashboard.mySubscriptions)}
                  </span>
                  <span className="mydash-title-icon">
                    <Icons.ArrowRight />
                  </span>
                </Link>
              </h2>
              <SubscriptionsForDashboard />
            </div>
            )}
          </div>
        </div>
      </section>
      {showNewsletterDialog && (
        <NewsletterDialog onClose={() => setHideNewsletterDialog(true)} />
      )}
    </>
  );
};
